import { useNavigate } from "react-router-dom";
import { getRoutePath } from "../../hooks/useNavigateRoute";
import { CreatePaymentMethod } from "../admin/billing/PaymentMethodCreateViewV2";

export function SetupPayment() {
  const navigate = useNavigate();
  return <CreatePaymentMethod onComplete={() => navigate(getRoutePath("home"))} />;
}
